import React, { useEffect, useState } from "react";
import { Card, CardBody, Badge } from "reactstrap";
import SectionService from "../../../services/OrderingServices/SectionService";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const statusConfig = {
  Available: { color: "success", label: "Available" },
  Occupied: { color: "danger", label: "Occupied" },
  Reserved: { color: "warning", label: "Reserved" },
};

const DetailSection = () => {
  const { id } = useParams();
  const [sectionDetail, setSectionDetail] = useState(null);

  useEffect(() => {
    const fetchSectionDetail = async () => {
      try {
        const response = await SectionService.detail(id); // replace with your endpoint
        setSectionDetail(response);
      } catch (error) {
        console.error("Failed to fetch section details", error);
      }
    };

    fetchSectionDetail();
  }, []);

  if (!sectionDetail) return <div>Loading...</div>;
  const breadcrumbItems = [{ title: "Back To List ", link: "/section" }];

  return (
    <div className="page-content">
      <div class="container-fluid">
        <BreadCrumb
          pageTitle="Section"
          title="Section Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <div className=" mt-4">
        {/* Section Info */}
        <div className="mb-4 text-center">
          <h2 className="fw-bold text-primary mb-1">
            {/* <FaChair className="me-2" /> */}
            {sectionDetail.name}
          </h2>
          <p className="text-muted">{sectionDetail.description}</p>
        </div>
        {/* Table Grid */}
        <Card>
          <CardBody className="row g-4">
            {sectionDetail.tables.map((table) => {
              const status =
                statusConfig[table.tableStatus] || statusConfig.Available;

              return (
                <div key={table.id} className="col-sm-6 col-md-4 col-lg-3">
                  <Card
                    className={`border-top border-${status.color} shadow-sm h-100 hover-scale bg-light`}
                  >
                    <CardBody className="d-flex flex-column justify-content-between h-100">
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5 className="mb-0 text-dark fw-semibold">
                            {table.tableName}
                          </h5>
                          <Badge color={status.color} pill>
                            {status.label}
                          </Badge>
                        </div>
                        <div className="text-muted small mb-1">
                          <strong>Description:</strong> {table.description}
                        </div>
                        <div className="text-muted small">
                          <strong>Capacity:</strong> {table.capacity} people
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              );
            })}
          </CardBody>
        </Card>

        {/* Optional footer */}
        {sectionDetail?.tables?.length === 0 && (
          <p className="text-center text-muted mt-4">No tables available.</p>
        )}
      </div>
    </div>
  );
};

export default DetailSection;
